module.exports = __webpack_public_path__ + "static/assets/6832702135a22b8d8b000acab6b210b9.jpg";